<template>
<div>
    <div class="loader" v-if="status === 'loading'"></div>
    <div v-show="status === 'loaded'">
        <editor api-key="zw6lmo9dcxpau7deksowxduiceo4aud9jvzla2q3biydvhq9"
                :init="inital"
                @init="editorIsLoaded"
                @change="refreshContent"
                @keyup="refreshContent"
                @redo="refreshContent"
                @undo="refreshContent"/>
    </div>
</div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import {upperCase} from "../../../helpers/tinymcePlugins/buttonUpperCase/plugin";

export default {
    name: "HtmlEditor",
    emits: ['isLoaded', 'contentChanged'],
    props: {
        height: {
            type: String,
            required: false
        },
        width: {
            type: String,
            required: false
        },
        pcontent: {
            type: String,
            required: false
        }
    },
    components: {
        Editor
    },
    computed: {
        inital() {
            return {
                select: "#app-editor",
                entity_encoding: 'UTF-8',
                height: !!this.height ? this.height : 500,
                width: !!this.width ? this.width : '100%',
                menubar: 'format table',
                automatic_uploads: true,
                file_picker_types: 'image',
                file_picker_callback: this.uploadTemporaryImage,
                language: 'es',
                contextmenu: 'paste | link image inserttable | cell row column deletetable',
                extended_valid_elements: 'img[!src|border:0|alt|title|width|height|style]a[name|href|target|title|onclick]',
                plugins: [
                    'advlist autolink lists link textcolor image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen table',
                    'insertdatetime media table paste code help wordcount advimage',
                    'upperCase'
                ],
                toolbar:
                    'undo redo | formatselect | bold italic underline strikethrough upperCase backcolor sizeselect fontsizeselect forecolor fontselect | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | \ table | removeformat | image ',
                setup: function () {
                    window.tinymce.PluginManager.add('upperCase', upperCase);
                }
            }
        }
    },
    data() {
        return {
            status: 'loading',
            content: '',
        }
    },
    methods: {
        uploadTemporaryImage(cb, value, meta) {
            let input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');

            input.onchange = function () {
                let file = this.files[0];

                let reader = new FileReader();
                reader.onload = function () {

                    let id = 'blobid' + (new Date()).getTime();
                    let blobCache = tinymce.activeEditor.editorUpload.blobCache;
                    let base64 = reader.result.split(',')[1];
                    let blobInfo = blobCache.create(id, file, base64);
                    blobCache.add(blobInfo);

                    cb(blobInfo.blobUri(), {title: file.name});
                };
                reader.readAsDataURL(file);
            };

            input.click();
        },
        /**
         * It is called when the tinymce is loaded. It is needed because of some fails if not loaded yet.
         * */
        async editorIsLoaded() {
            // If a content comes in props, set it right now because tinymce is available
            if (!!this.pcontent) {
                await this.setContent(this.pcontent);
            }

            this.$emit('isLoaded', {});
            this.status = 'loaded';
        },
        /**
         * Sets the provided content as component data and editor content.
         *
         * @param content
         * @returns {Promise<void>}
         */
        async setContent(content) {
            this.content = content;
            await tinymce.activeEditor.setContent(content);
        },
        /**
         * Sets the editor content as component data, and emits that content in a 'contentChanged' event.
         *
         * @returns {Promise<void>}
         */
        async refreshContent() {
            this.content = await this.getContent();
            this.$emit('contentChanged', {content: this.content});
        },
        /**
         * Gets the content from the editor.
         *
         * @returns {Promise<*>}
         */
        async getContent() {
            return await tinymce.activeEditor.getContent();
        }
    },
    setup() {
        return {}
    }
}
</script>

<style>
.tox-notifications-container {
    display: none !important;
}

</style>
